import { useState } from 'react';

const faqs = [
  {
    question: 'Who is the best dentist in Kondapur Hyderabad?',
    answer: 'Dr. Kavitha Samanthula at Sri Maruthi Teeth Empire Dental Clinic on Botanical Garden Road, Kondapur is one of the top-rated dentists in Hyderabad with 10+ years of experience and a 4.9-star Google rating from 300+ patients. She specializes in dental implants, cosmetic dentistry, and painless root canal treatments.',
  },
  {
    question: 'How much do dental implants cost in Kondapur Hyderabad?',
    answer: 'Dental implant costs at Sri Maruthi Teeth Empire in Kondapur vary based on the type of implant and individual needs. We offer affordable dental implant solutions with flexible payment options. Contact us at +918340978930 for a personalized consultation and cost estimate.',
  },
  {
    question: 'Is root canal treatment painful at Sri Maruthi Teeth Empire?',
    answer: 'No, root canal treatment at Sri Maruthi Teeth Empire Kondapur is virtually painless. We use advanced techniques and modern anesthesia to ensure complete comfort during the procedure. Dr. Kavitha specializes in painless root canal therapy with a high success rate.',
  },
  {
    question: 'What are the working hours of Sri Maruthi Teeth Empire dental clinic in Kondapur?',
    answer: 'Sri Maruthi Teeth Empire Dental Clinic in Kondapur, Hyderabad is open Monday to Saturday from 9:00 AM to 8:00 PM. We are closed on Sundays. For emergency dental care, call +918340978930.',
  },
  {
    question: 'Where is Sri Maruthi Teeth Empire dental clinic located in Kondapur?',
    answer: 'Sri Maruthi Teeth Empire is located at Ragini Residency, Second Floor 2B, Botanical Garden Road, Kondapur, Hyderabad, Telangana 500084. We are easily accessible from Hitech City, Gachibowli, Kothaguda, and Masjid Banda areas.',
  },
  {
    question: 'Does Sri Maruthi Teeth Empire offer teeth whitening services in Hyderabad?',
    answer: 'Yes, Sri Maruthi Teeth Empire in Kondapur offers professional teeth whitening treatments that deliver instant, visible results in just one visit. Our advanced whitening technology ensures safe and effective brightening of your smile.',
  },
  {
    question: 'Is there an emergency dentist available in Kondapur?',
    answer: 'Yes, Sri Maruthi Teeth Empire provides emergency dental care in Kondapur, Hyderabad. For dental emergencies such as severe toothache, broken teeth, or dental trauma, call us immediately at +918340978930 and we will accommodate you as soon as possible.',
  },
  {
    question: 'What cosmetic dentistry services are available at Sri Maruthi Teeth Empire Kondapur?',
    answer: 'Sri Maruthi Teeth Empire in Kondapur offers comprehensive cosmetic dentistry including dental veneers, smile makeovers, teeth whitening, dental bonding, and gum contouring. Dr. Kavitha creates personalized treatment plans to help you achieve your dream smile.',
  },
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" aria-labelledby="faq-heading" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
            <span className="text-sm font-semibold text-teal-600">Frequently Asked Questions</span>
          </div>
          <h2
            id="faq-heading"
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Common Questions About Dental Care in Kondapur
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Find answers to the most common questions about <strong>dental treatments</strong>, pricing, and appointments at <strong>Sri Maruthi Teeth Empire</strong>, Kondapur, Hyderabad.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <article
              key={index}
              itemScope
              itemType="https://schema.org/Question"
              className={`rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                openIndex === index
                  ? 'border-teal-200 bg-teal-50/30 shadow-md'
                  : 'border-gray-100 bg-white hover:border-gray-200'
              }`}
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3 itemProp="name" className="text-base font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-teal-500 text-white rotate-180'
                      : 'bg-gray-100 text-gray-500'
                  }`}
                  aria-hidden="true"
                >
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </div>
              </button>
              <div
                id={`faq-answer-${index}`}
                itemScope
                itemType="https://schema.org/Answer"
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}
              >
                <div className="px-6 pb-6">
                  <p itemProp="text" className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 text-sm mb-4">
            Still have questions about dental care in Kondapur?
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="tel:+918340978930"
              aria-label="Call Sri Maruthi Teeth Empire dental clinic Kondapur"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg" aria-hidden="true"></i>
              Call +91 83409 78930
            </a>
            <a
              href="https://wa.me/918340978930?text=Hi%2C%20I%20have%20a%20question%20about%20dental%20treatment%20at%20Sri%20Maruthi%20Teeth%20Empire"
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Ask Sri Maruthi Teeth Empire on WhatsApp"
              className="inline-flex items-center gap-2 bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
              Ask on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
